import { useTranslation } from "react-i18next";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    CircularProgress,
    useTheme,
} from "@mui/material";
import { Button } from "@foodpilot/foods";

type DeleteConfirmDialogProps = {
    open: boolean;
    onClose: () => void;
    onConfirmDelete: () => void;
    isDeleting: boolean;
    deleteCount: number;
    fileName?: string;
};

export const DeleteConfirmDialog = (props: DeleteConfirmDialogProps) => {
    const { open, onClose, onConfirmDelete, isDeleting, deleteCount, fileName } = props;
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                <Typography variant="body1" fontSize={18} fontWeight={theme.typography.fontWeightMedium}>
                    {t("settings.media_library.delete_dialog.title", "Delete Media")}
                </Typography>
            </DialogTitle>
            <DialogContent>
                {fileName && (
                    <Typography variant="body1" sx={{ mb: 2, fontWeight: "medium" }}>
                        {t("settings.media_library.delete_dialog.file_name", "File: {{ fileName }}", { fileName })}
                    </Typography>
                )}
                <Typography>
                    {t(
                        deleteCount > 1 ?
                            "settings.media_library.delete_dialog.message_other"
                        :   "settings.media_library.delete_dialog.message",
                        deleteCount > 1 ?
                            "Are you sure you want to delete these {{ count }} files? This action cannot be undone."
                        :   "Are you sure you want to delete this file? This action cannot be undone.",
                        { count: deleteCount },
                    )}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onConfirmDelete}
                    variant="primary"
                    sx={{
                        background: `linear-gradient(${theme.palette.error[900]}, ${theme.palette.error[700]})`,
                    }}
                >
                    {isDeleting ?
                        <CircularProgress size={24} />
                    :   t("settings.media_library.delete_dialog.confirm", "Delete")}
                </Button>
                <Button variant="ternary" onClick={onClose}>
                    {t("settings.media_library.delete_dialog.cancel", "Cancel")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
